// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KEGqr","left":"styles_left__3uHEC","select":"styles_select__1kNtg"};